import React, { useEffect } from 'react';
import LoadableMonacoEditor from 'js/components/elements/editors/monaco/LoadableMonacoEditor';
import { fetchDataSamples } from 'js/actions';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_DATA_SAMPLES_REQUEST } from 'js/constants/actionTypes';
import { CenteredLoader } from 'new/elements/CenteredLoader';
import useInputSamples from 'js/components/recipeBuilder/NexsetSampleView/hooks/useInputSamples';

interface ExpandViewProps {
  samples?: any;
  item: any;
}

const EDITOR_OPTIONS = {
  readOnly: true,
  minimap: { enabled: false },
};

export const ExpandView = ({ item }: ExpandViewProps) => {
  const dispatch = useAppDispatch();

  const isLoading = useIsLoading(GET_DATA_SAMPLES_REQUEST);

  const inputSamples = useInputSamples(item.id);

  useEffect(() => {
    loadSamples();
  }, [item.id]);

  const loadSamples = () => {
    const id = item?.id;
    dispatch(fetchDataSamples(id));
  };

  if (isLoading && !Boolean(inputSamples)) {
    return <CenteredLoader />;
  }

  if (!item || !Boolean(inputSamples)) {
    return null;
  }
  return (
    <LoadableMonacoEditor
      language="json"
      value={inputSamples}
      height={300}
      theme="light"
      options={EDITOR_OPTIONS}
    />
  );
};
